// Scroll-reveal global para secciones del kit ME. Init único (guard).
// En el editor de Shopify cada ajuste que cambia vuelve a dibujar la sección con
// elementos NUEVOS: si nadie los observa se quedan en opacity 0 y la sección sale
// vacía. Por eso en el editor todo se muestra de una, y fuera de él se vuelve a
// observar lo que llegue con `shopify:section:load`.
(function () {
  if (window.__meReveal) return;
  window.__meReveal = true;
  var enEditor = !!(window.Shopify && window.Shopify.designMode);
  var io = null;
  if (!enEditor && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('me-reveal-in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  }
  function observar(raiz) {
    var els = (raiz || document).querySelectorAll('[data-me-reveal]:not(.me-reveal-in)');
    els.forEach(function (e) {
      if (io) io.observe(e);
      else e.classList.add('me-reveal-in');
    });
  }
  if (document.readyState !== 'loading') observar();
  else document.addEventListener('DOMContentLoaded', function () { observar(); });
  document.addEventListener('shopify:section:load', function (ev) { observar(ev.target); });
})();
